// src/components/tools/room-ideas/RoomIdeaResults.jsx

import React from "react";

const RoomIdeaResults = ({ results, onReset }) => {
  if (!results || !results.images || results.images.length === 0) {
    return (
      <div className="room-idea-results">
        <h2>No ideas generated</h2>
        <p>We couldn’t generate ideas for this request. Please try again.</p>
        <button onClick={onReset}>Start Over</button>
      </div>
    );
  }

  const {
    images,
    request: {
      roomType,
      style,
      budget,
      primaryColor,
      secondaryColor
    }
  } = results;

  return (
    <div className="room-idea-results">
      <h2>Your Upgrade Ideas</h2>

      {/* Summary */}
      <div className="summary">
        <p>
          <strong>Room:</strong>{" "}
          {roomType ? roomType.replace("_", " ") : "—"}
        </p>
        <p>
          <strong>Style:</strong> {style || "—"}
        </p>
        <p>
          <strong>Budget:</strong> {budget || "—"}
        </p>
        <p>
          <strong>Colors:</strong>{" "}
          <span
            style={{
              display: "inline-block",
              width: 16,
              height: 16,
              backgroundColor: primaryColor,
              marginRight: 6,
              border: "1px solid #ccc"
            }}
          />
          <span
            style={{
              display: "inline-block",
              width: 16,
              height: 16,
              backgroundColor: secondaryColor,
              border: "1px solid #ccc"
            }}
          />
        </p>
      </div>

      {/* Image Collage */}
      <div className="image-collage">
        {images.map((image, index) => {
          if (!image || !image.src) {
            return null;
          }

          return (
            <div key={index} className="collage-item">
              <img
                src={image.src}
                alt={`Upgrade idea ${index + 1}`}
                style={{
                  width: "100%",
                  height: "auto",
                  borderRadius: 8
                }}
              />
            </div>
          );
        })}
      </div>

      {/* Actions */}
      <div className="results-actions">
        <button onClick={onReset}>Start Over</button>
      </div>
    </div>
  );
};

export default RoomIdeaResults;
